<script setup>
import {ref, defineProps, onMounted, computed} from 'vue';
import MsColumnChart from './MsColumnChart.vue';
import MsDonutChart from './MsDonutChart.vue';
import {useChart} from './composables/use-chart.js';

const chartName = ref('');
const props = defineProps({
  name: String,
  type: String,
  data: Array,
  dataZero: Boolean,
  title: String,
  height: Number,
  options: Object,
  loading: Boolean,
});
const charts = {
  MsColumnChart,
  MsDonutChart,
};
const {getChartType} = useChart();

const hasData = computed(() => {
  return props.data.length > 0 && !props.dataZero ? true : false;
  //return false;
});

const iconNoData = computed(() => {
  if (props.type == 2) {
    return true;
  }
  return false;
});

onMounted(() => {
  chartName.value = getChartType(props.type);
});
</script>
<template>
  <div id="msChart">
    <div class="no-data" v-if="!hasData">
      <div class="bg" v-if="iconNoData">
        <img src="@/assets/images/empty/Pie_NoData.png" class="img-bg" />
      </div>
      <div class="bg" v-if="!iconNoData">
        <img src="@/assets/images/empty/Collum_NoData.png" class="img-bg" />
      </div>
      <div class="title">Không có dữ liệu</div>
    </div>
    <component
      v-else
      :is="charts[chartName]"
      :name="props.name"
      :data="props.data"
      :title="props.title"
      :height="props.height"
      :options="props.options"
    ></component>
    <div id="chartLoading" class="loading" v-show="props.loading">
      <div class="loading-cover"></div>
      <div class="loading-svg">
        <div class="effect-1 effects"></div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
#msChart {
  height: 100%;
}
.no-data {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  .title {
    margin-top: 10px;
  }
}
</style>
